import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["address", "tab", "panel", "progress"];
  static values = {
    activeIndex: { type: Number, default: 0 },
    interval: { type: Number, default: 6500 },
  };

  connect() {
    this.showActiveScreenshot();
    this.startTimer();
  }

  disconnect() {
    this.stopTimer();
  }

  select(event) {
    event.preventDefault();
    this.activate(Number(event.currentTarget.dataset.screenshotIndex));
  }

  activeIndexValueChanged() {
    this.showActiveScreenshot();
  }

  activate(index) {
    if (!Number.isInteger(index) || index < 0 || index >= this.tabTargets.length) {
      return;
    }

    this.activeIndexValue = index;
    this.startTimer();
  }

  next() {
    this.activate((this.activeIndexValue + 1) % this.tabTargets.length);
  }

  showActiveScreenshot() {
    this.tabTargets.forEach((tab, index) => {
      const isActive = index === this.activeIndexValue;

      tab.setAttribute("aria-selected", isActive.toString());
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
      tab.dataset.state = isActive ? "active" : "inactive";
    });

    this.panelTargets.forEach((panel, index) => {
      const isActive = index === this.activeIndexValue;

      panel.toggleAttribute("hidden", !isActive);
      panel.dataset.state = isActive ? "active" : "inactive";
    });

    if (this.hasAddressTarget) {
      this.addressTarget.textContent =
        this.tabTargets[this.activeIndexValue]?.dataset.screenshotAddress || "";
    }
  }

  startTimer() {
    this.stopTimer();
    this.restartProgress();

    if (this.tabTargets.length < 2) {
      return;
    }

    this.timer = window.setTimeout(() => this.next(), this.intervalValue);
  }

  stopTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  restartProgress() {
    this.progressTargets.forEach((progress, index) => {
      progress.style.transition = "none";
      progress.style.width = "0%";

      if (index !== this.activeIndexValue) {
        return;
      }

      window.requestAnimationFrame(() => {
        progress.style.transition = `width ${this.intervalValue}ms linear`;
        progress.style.width = "100%";
      });
    });
  }
}
